import {
  UNIVERSITY_LIST_REQ,
  UNIVERSITY_LIST_SUCCESS,
  UNIVERSITY_LIST_FAILED,
  UPDATE_UNIVERSITY_FAILED,
  UPDATE_UNIVERSITY_SUCCESS,
  UPDATE_UNIVERSITY_RESET,
  DELETE_UNIVERSITY_REQ,
  DELETE_UNIVERSITY_FAILED,
  DELETE_UNIVERSITY_SUCCESS,
  DELETE_UNIVERSITY_RESET,
  CREATE_UNIVERSITY_FAILED,
  CREATE_UNIVERSITY_REQ,
  CREATE_UNIVERSITY_SUCCESS,
  CREATE_UNIVERSITY_RESET,
  UNIVERSITY_LIST_RESET,
  UPDATE_UNIVERSITY_REQ,
  UNIVERSITY_SINGLE_DATA_REQ,
  UNIVERSITY_SINGLE_DATA_SUCCESS,
  UNIVERSITY_SINGLE_DATA_FAILED,
  UNIVERSITY_SINGLE_DATA_RESET,
} from "../Constants/universityConstants";
import axiosConfig from "../Core/axiosConfig";

export const LIST_UNIVERSITIES = () => async (dispatch, getState) => {
  try {
    dispatch({ type: UNIVERSITY_LIST_REQ });
    const { LoginReducer } = getState();
    let { data } = await axiosConfig.get(`/university`);
    if (data?.Result.includes("Error")) {
      dispatch({ type: UNIVERSITY_LIST_FAILED, payload: data.Result });
    } else {
      dispatch({ type: UNIVERSITY_LIST_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({ type: UNIVERSITY_LIST_FAILED, payload: `Error-${ex.message}` });
  }
};

export const LIST_UNIVERSITIES_RESET = () => (dispatch) => {
  dispatch({ type: UNIVERSITY_LIST_RESET });
};

export const UNIVERSITY_SINGLE_DATA = (ID) => async (dispatch, getState) => {
  try {
    dispatch({ type: UNIVERSITY_SINGLE_DATA_REQ });
    const { LoginReducer } = getState();
    let { data } = await axiosConfig.get(`/university/${ID}`);
    if (data.Result.includes("Error")) {
      dispatch({ type: UNIVERSITY_SINGLE_DATA_FAILED, payload: data.Result });
    } else {
      dispatch({ type: UNIVERSITY_SINGLE_DATA_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({
      type: UNIVERSITY_SINGLE_DATA_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};

export const UNIVERSITY_SINGLE_FORM_RESET = () => (dispatch) => {
  dispatch({ type: UNIVERSITY_SINGLE_DATA_RESET });
};

export const UNIVERSITY_LIST_CREATE =
  (university_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_UNIVERSITY_REQ });
      university_data.University_Name = university_data.University_Name.trim();
      const { LoginReducer } = getState();
      let { data } = await axiosConfig.post(`/university`, university_data);
      if (data.Result.includes("Error")) {
        dispatch({ type: CREATE_UNIVERSITY_FAILED, payload: data.Result });
      } else {
        dispatch({ type: CREATE_UNIVERSITY_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({
        type: CREATE_UNIVERSITY_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_LIST_CREATE_RESET_FORM = () => (dispatch) => {
  dispatch({ type: CREATE_UNIVERSITY_RESET });
};

export const UNIVERSITY_LIST_UPDATE =
  (Id, university_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_UNIVERSITY_REQ });
      const { LoginReducer } = getState();
      let { data } = await axiosConfig.put(
        `/university/${Id}`,
        university_data
      );

      if (data.Result.includes("Error")) {
        dispatch({ type: UPDATE_UNIVERSITY_FAILED, payload: data.Result });
      } else {
        dispatch({ type: UPDATE_UNIVERSITY_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({
        type: UPDATE_UNIVERSITY_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_LIST_UPDATE_RESET = () => (dispatch) => {
  dispatch({ type: UPDATE_UNIVERSITY_RESET });
};

export const UNIVERSITY_LIST_DELETE = (Id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_UNIVERSITY_REQ });
    const { LoginReducer } = getState();
    let { data } = await axiosConfig.delete(`/university/${Id}`);

    if (data.Result.includes("Error")) {
      dispatch({ type: DELETE_UNIVERSITY_FAILED, payload: data.Result });
    } else {
      dispatch({ type: DELETE_UNIVERSITY_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({
      type: DELETE_UNIVERSITY_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};

export const UNIVERSITY_LIST_DELETE_RESET = () => (dispatch) => {
  dispatch({ type: DELETE_UNIVERSITY_RESET });
};
